@if (formGroup) {
  @if (formGroup.get(formGroupOrControlName); as control) {
    <div [formGroup]="formGroup" class="metabi-control">
      <app-field-label [for]="formGroupOrControlName">
        {{ getLabel() }}
      </app-field-label>
      <textarea
        [formControlName]="formGroupOrControlName"
        [placeholder]="getLabel()"
        rows="10"
      ></textarea>
      @if (control.errors && control.touched) {
        <app-field-error>
          {{ curateValidationHint(control) }}
        </app-field-error>
      }
    </div>
  }
}
